/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  addresses: [],
  postcode: null,
  address: {},
};

const addressSearchReducer = createReducer(initialState, {
  [types.ADDRESS_SEARCH_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.ADDRESS_SEARCH_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      addresses: action.results,
    };
  },
  [types.SELECTED_ADDRESS_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.SELECTED_ADDRESS_REQUEST_SUCCESS](state, action) {
    return {
      address: action.result,
      postcode: null,
      addresses: [],
    };
  },
  [types.ADDRESS_RESET_SEARCH_INPUT](state, action) {
    return {
      ...state,
      postcode: null,
      addresses: [],
    };
  },
  [types.ADDRESS_SEARCH_FIELD_CHANGE](state, action) {
    return {
      ...Object.assign({}, state, { [action.field]: action.value })
    };
  },

});

export default addressSearchReducer;
